import { ShieldCheck, Car, HeadphonesIcon, Users, Sparkles } from "lucide-react";

const ITEMS = [
  { icon: HeadphonesIcon, title: "24/7 Assistance", body: "Support whenever you need it." },
  { icon: Users, title: "Experienced Drivers", body: "Professional & reliable chauffeurs." },
  { icon: Car, title: "Wide Fleet", body: "Cars, SUVs, Travellers & Buses." },
  { icon: Sparkles, title: "Comfortable Travel", body: "Clean & well-maintained vehicles." },
];

export default function Benefits() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 mt-10 sm:mt-14" data-testid="benefits-strip">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {ITEMS.map((it) => (
          <div key={it.title} className="rounded-xl border border-slate-200 bg-white p-4 flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-amber-50 grid place-items-center shrink-0">
              <it.icon className="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <div className="font-medium text-slate-900 text-sm">{it.title}</div>
              <div className="text-slate-500 text-xs mt-0.5">{it.body}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
